/* eslint-disable react/jsx-curly-newline */
import React, { useContext } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import actionTypes from '@context/actionTypes';
import { store } from '@context/store';
import calendar from '@assets/images/calendar.svg';

export default function AvailabilityWidgetDLP({ cityID }: { cityID: number }) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const router = useRouter();

  return (
    <div className="bg-white border border-gray-divider flex flex-col max-w-1024 mb-0 mt-4 mx-0 p-5 rounded-lg d:flex-col d:justify-between d:mx-auto">
      <div className="flex items-start">
        <Image src={calendar} width={24} height={24} alt="Calendar" />

        <div className="font-rp-pn-regular ml-4 text-rp-primary-black text-sm d:text-17">
          <span className="font-rp-pn-semi-bold">Weekends are getting busy.</span> Try a weekday to
          see more availability.
        </div>
      </div>

      <div className="flex mt-5 space-x-3">
        <button
          id="openDatePickerButton"
          className="bg-rp-lighter-alice-blue flex font-rp-pn-semi-bold items-center justify-center leading-6 px-3 py-3 rounded-xl text-15 text-rp-primary-dark w-full d:px-4 d:text-base"
          type="button"
          onClick={() =>
            dispatch({
              type: actionTypes.OPEN_DATE_PICKER,
              payload: true,
            })
          }
        >
          Change Date
        </button>

        <button
          id="showAvailableHotelsButton"
          className="bg-rp-lighter-alice-blue flex font-rp-pn-semi-bold items-center justify-center leading-6 px-3 py-3 rounded-xl text-15 text-rp-primary-dark w-full d:px-4 d:text-base"
          type="button"
          onClick={() => {
            dispatch({
              type: actionTypes.TOGGLE_ONLY_SHOW_AVAILABLE_HOTELS,
              payload: true,
            });

            router.push(`/hotel-day-passes?city_id=${cityID}`);
          }}
        >
          See Available Hotels
        </button>
      </div>
    </div>
  );
}
